import React, { useContext, useMemo } from 'react';

import { Icon } from '@mdi/react';

import { Text, Chip } from 'components/atoms';
import { mdiAccount, mdiBellRing } from '@mdi/js';
import { useLocale } from 'lib';
import { alarmCenterSelector } from 'features/details';
import { useSelector } from 'react-redux';
import { connectedCustomerSelector } from 'features/identity';
import { professionalResponderSelector } from 'features/details/response/professional';
import { AlarmProfessionalResponderStatus } from '@x-guard/xgac-types/xgac';
import { stateSelector as chatStateSelector } from 'features/details/chat';
import { Image } from 'components/molecules';
import { alarmContext } from '../alarmContext';
import { useCallPeople } from '../helpers/helpersList';
import styles from './style.module.scss';
import { OverlayContext } from '../../../../molecules/overlay/overlayContext';

export * from './survey';

const initials = (name: string) => name
  .split(/\s+/)
  .filter(Boolean)
  .slice(0, 2)
  .map((part) => part[0]?.toUpperCase() ?? '')
  .join('');

export const Acknowledge = () => {

  const { t } = useLocale();
  const { onRequestAckForm } = useContext(alarmContext);
  const { overlayCount } = useContext(OverlayContext);
  const responder = useSelector(professionalResponderSelector);
  const alarmProfessionalResponderBlocksAcknowledgement = [
    AlarmProfessionalResponderStatus.OnLocation,
  ].includes(responder?.status);

  const currentCustomer = useSelector(connectedCustomerSelector);
  const alarmCenter = useSelector(alarmCenterSelector);
  const { openHelperCallIds } = useSelector(chatStateSelector);
  const connected = useCallPeople(Date.now())
    .filter((person) => person.connectedAt);
  const shown = connected.slice(0, 5);
  const hiddenCount = connected.length - shown.length;

  const blockedByAlarmCenter = useMemo(() => {

    return alarmCenter && alarmCenter._id !== currentCustomer._id;

  }, [currentCustomer, alarmCenter]);

  const blockedByOverlay = overlayCount > 0;

  const getAckComponent = () => {

    if (alarmProfessionalResponderBlocksAcknowledgement) {

      return <>
        <hr/>
        <Text variant={'titleSpan'} theme={'error'} textAlign={'center'} className={styles.subtitle}>
          {t('Alarm_Detail_Acknowledge.BlockedByAlarmProfessionalResponder')}
        </Text>
      </>;

    }

    if (blockedByAlarmCenter) {

      return <>
        <hr/>
        <Text variant={'titleSpan'} className={styles.subtitle}>
          {t('Alarm_Detail_Acknowledge.Blocked', alarmCenter)}
        </Text>
      </>;

    }

    return <>
      <Text variant={'titleSpan'} className={styles.subtitle}>
        {t('Alarm_Detail_Acknowledge.Subtitle')}
      </Text>
      <hr/>
      <Chip
        label={t('Alarm_Detail_Acknowledge.Button_Label')}
        size={'large'}
        disabled={blockedByOverlay}
        variant={'green400'}
        onClick={onRequestAckForm}
      />
    </>;

  };

  return (
    <div className={styles.acknowledge}>
      <Text variant={'boldSpan'} className={styles.title}>
        <Icon className={styles.icon} path={mdiBellRing}/>
        {t('Alarm_Detail_Acknowledge.Title')}
      </Text>
      {openHelperCallIds.length > 0 && (
        <div className={styles.callWarning}>
          <p>{t('Alarm_Detail_Acknowledge.ActiveCall')}</p>
          {shown.length > 0 && (
            <div className={styles.faces}>
              {shown.map((person, index) => (
                <div key={person.id} className={styles.face} style={{ zIndex: index }} title={person.name}>
                  {person.image && <Image src={person.image} alt="" className={styles.faceImage}/>}
                  {!person.image && (
                    <span>{initials(person.name) || <Icon path={mdiAccount} size="22px"/>}</span>
                  )}
                </div>
              ))}
              {hiddenCount > 0 && <span className={styles.moreFaces}>{`+ ${hiddenCount}`}</span>}
            </div>
          )}
        </div>
      )}
      {getAckComponent()}
    </div>
  );

};
